import React from "react";

const RefreshIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.835938 8C0.835938 4.41015 3.74609 1.5 7.33594 1.5C9.13154 1.5 10.7579 2.22874 11.9337 3.4054C12.4633 3.9353 13.0424 4.62497 13.5026 5.19964V2.66667C13.5026 2.39052 13.7265 2.16667 14.0026 2.16667C14.2787 2.16667 14.5026 2.39052 14.5026 2.66667V6.66667C14.5026 6.94281 14.2787 7.16667 14.0026 7.16667H10.0026C9.72646 7.16667 9.5026 6.94281 9.5026 6.66667C9.5026 6.39052 9.72646 6.16667 10.0026 6.16667H12.9927C12.9338 6.0914 12.8718 6.01269 12.8071 5.93138C12.3401 5.34381 11.7487 4.6349 11.2264 4.11226C10.2304 3.11562 8.85554 2.5 7.33594 2.5C4.29837 2.5 1.83594 4.96243 1.83594 8C1.83594 11.0376 4.29837 13.5 7.33594 13.5C9.84265 13.5 11.9589 11.8226 12.621 9.52804C12.6976 9.26272 12.9747 9.10971 13.2401 9.18627C13.5054 9.26283 13.6584 9.53998 13.5818 9.80529C12.7995 12.5164 10.3 14.5 7.33594 14.5C3.74609 14.5 0.835938 11.5899 0.835938 8Z"
        fill="#6E00BE"
      />
    </svg>
  );
};

export default RefreshIcon;
